/* unplugin-vue-components disabled */import { render } from "./member_expert.vue?vue&type=template&id=4bdbdae3&scoped=true"
import script from "./member_expert.vue?vue&type=script&lang=js"
export * from "./member_expert.vue?vue&type=script&lang=js"

import "./member_expert.vue?vue&type=style&index=0&id=4bdbdae3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdbdae3"]])

export default __exports__